module.exports = __webpack_public_path__ + "media/images/mobile/abouts/team-ed388c48744836df8c9705baeca43392.jpg";